import { Image } from "antd";
import React from "react";
import GlobalStoreContext from "../../context/GlobalStoreContext";
import { WaypointStep } from "../../models/WaypointStep";
import WaypointStepAttachmentPreviewToolBar from "../Project/ProjectLogistics/LogisticsLegend/MapLocationEdit/Waypoint/waypointStepAttachmentPreviewToolBar";

interface WaypointStepViewProps {
    waypointStep: WaypointStep;
    index: number;
    onClick?: (step: WaypointStep) => void;
}

const WaypointStepView: React.FC<WaypointStepViewProps> = ({ waypointStep, index }) => {
    const context = React.useContext(GlobalStoreContext);
    const focusWaypoint = () => {
        context.setCurrentWaypointStep(waypointStep);
    };
    const blurWaypoint = () => {
        context.setCurrentWaypointStep(null);
    };
    return (
        <div
            className="flex flex-row items-center justify-between gap-2 w-full"
            onMouseEnter={focusWaypoint}
            onMouseLeave={blurWaypoint}
            id={`waypoint-step-${waypointStep.id}`}
        >
            <div className="flex flex-row items-start gap-1 text-sm text-gray-600 flex-1">
                <div className="font-semibold">{index + 1}.</div>
                <div>{waypointStep.instruction}</div>
            </div>

            {waypointStep.pictureUrl && (
                <div className="flex flex-row items-center gap-2 flex-1 h-32 overflow-clip">
                    <Image
                        alt="waypoint step image attachment preview"
                        preview={{
                            toolbarRender: (
                                _: any,
                                {
                                    transform: { scale },
                                    actions: {
                                        onFlipY,
                                        onFlipX,
                                        onRotateLeft,
                                        onRotateRight,
                                        onZoomOut,
                                        onZoomIn,
                                        onReset,
                                    },
                                }
                            ) => (
                                <WaypointStepAttachmentPreviewToolBar
                                    onFlipY={onFlipY}
                                    onFlipX={onFlipX}
                                    onRotateLeft={onRotateLeft}
                                    onRotateRight={onRotateRight}
                                    onZoomOut={onZoomOut}
                                    onZoomIn={onZoomIn}
                                    onReset={onReset}
                                />
                            ),
                        }}
                        src={waypointStep.pictureUrl}
                    />
                </div>
            )}
        </div>
    );
};

export default WaypointStepView;
